import { forIn, merge } from 'lodash';

let tokenHandlerService = ($location, authStorageService, auth0Service) => {

  const handleTokensHash = () => {
    return auth0Service.parseHash({ hash: $location.hash() })
      .then(handleTokens);
  };

  const handleTokens = result => {
    if (!result) {
      throw {
        error: 'missing_tokens',
        errorDescription: 'URL does not contain the access and ID tokens.'
      };
    }

    const profile = merge(authStorageService.getProfile(), transformProfile(result.idTokenPayload));

    authStorageService.setAccessToken(result.accessToken);
    authStorageService.setProfile(profile);

    return profile;
  };

  const transformProfile = idTokenPayload => {
    const propertyPrefix = 'https://www.lobby.travel/';

    let profile = {};

    forIn(idTokenPayload, (value, key) => {
      key = key.startsWith(propertyPrefix) ? key.substring(propertyPrefix.length) : key;

      profile[key] = value;
    });

    return profile;
  };

  return {
    handleTokensHash,
    handleTokens
  };
};

tokenHandlerService.$inject = [ '$location', 'authStorageService', 'auth0Service' ];

export default tokenHandlerService;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/journey-ui/auth/services/tokenHandler.service.js